import { render, staticRenderFns } from "./formData.vue?vue&type=template&id=f3240b16&scoped=true&"
import script from "./formData.vue?vue&type=script&lang=js&"
export * from "./formData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3240b16",
  null
  
)

export default component.exports